module.exports = "<jhi-button saving\n    icon=\"fas fa-cloud\"\n    [isLoading]=\"isLoading\"\n    [isDisabled]=\"isLoading || isDisabled\"\n    iconLeft\n    (onClick)=\"onClickButton($event)\">\n    Enregistrer le brouillon\n    <ng-content></ng-content>\n</jhi-button>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/app/shared/components/forms/button/save-draft-requete-button/save-draft-requete-button.component.html
// module id = 844
// module chunks = 0